const mailingList = (state) => state.mailingList;
const mailReportDetails = (state) => state.mailReportData

export default {
  mailingList,
  mailReportDetails
}


// WEBPACK FOOTER //
// ./src/store/modules/mailing/getters.js